<template>
  <div class="home">
<div class="works">
	<div class="works-ban">
		<h2>Appreciation Works</h2>
		<p>Home / Appreciation Works</p>
		<p><span :class="{'acts':channel_id==3}" @click="buff(3)">game player</span><span :class="{'acts':channel_id==4}" @click="buff(4)"> appreciation </span><span :class="{'acts':channel_id==1}" @click="buff(1)">works</span></p>
	</div>
	<div class="home-ct">
<div class="wok-con">
	<el-row :gutter="20">
		<el-col :span="10">
			
			<img class="pic" :src="data.originalPic" />
		</el-col>
		<el-col :span="14">
			<div class="blur">
				<h3>{{data.title}}</h3>
				<div class="aut">
					<span>{{data.author}}</span><span>{{data.dtTime}}</span>
				</div>
				<p>{{data.content}} </p>
			</div>
		</el-col>
	</el-row>
	<div class="con-buff">
		<div class="tit">
			Detailed description
		</div>
		<div class="con">
		{{data.content}}
		</div>
		
	</div>
 
 </div>

		</div>
</div>
  
    </div>
</template>
<script>




export default {

  data() {
    return {
	id:'',
    data:'',
	channel_id:0
    };
  }, 
 mounted() {
	 
this.id = this.$route.query.id;
		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsDetail",
			  data: {id:this.id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
						
					this.data=data.data;
					this.channel_id=data.data.channel_id
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
				this.channel_id=item
				this.sandMate()
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.wok-con{
		margin-top: 30px;
		.l1{
			line-height: 40px;
		}
		.l2{
			color: #8E8D8D;
		}
	
		.pic{
			width: 100%;
		}
		
		.blur{
			h3{
				font-size: 26px;
			}
			.aut{
				line-height: 60px;
				span{
					margin-right: 20px;
				
				}
			}
		}
		
		.con-buff{
			margin-top: 30px;
			.tit{
				font-size: 24px;
				color: #0A0A0A;
				font-weight: bolder;
				line-height: 50px;
				border-bottom: 1px solid #EAEAEA;
			}
			.con{
				color: #5A5A5A;
				border-bottom: 1px solid #EAEAEA;
				padding: 20px 0;
			}
		}
		
	}


	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 157px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

}

</style>